<template>
  <div>
    <b-table
      :fields="fields"
      :items="groups"
      :sort-by.sync="_sortBy"
      :sort-desc.sync="_sortDesc"
      responsive="sm"
      outlined
      hover
      show-empty
      small
    >
      <template #empty>
        <h6 class="text-center text-italic text-uppercase">
          {{ $t("page.groups.emptyList") }}
        </h6>
      </template>
      <template #head()="data">
        <div
          :class="{ clickable: data.field.sort }"
          @click="data.field.sort && setSort(data.column)"
        >
          {{ $t(data.label) }}
          <svg
            v-if="data.column === _sortBy"
            viewBox="0 0 16 16"
            class="sort-icon"
          >
            <path fill-rule="evenodd" :d="sortIcon"></path>
          </svg>
        </div>
      </template>
      <template #cell(name)="data">
        {{ data.value }}
      </template>
      <template #cell(status)="data">
        <b-badge
          class="text-white font-weight-normal"
          :variant="statusVariant[data.value]"
        >
          {{ $t(`page.groups.status.${data.value}`) }}
        </b-badge>
      </template>
      <template #cell(commentPermissions)="data">
        <b-badge
          class="text-white font-weight-normal"
          :variant="comPersmissionVariant[data.value]"
        >
          {{ $t(`page.groups.comments.${data.value}`) }}
        </b-badge>
      </template>
      <template #cell(membersCount)="data">
        {{ data.value }}
      </template>
      <template #cell(details)="data">
        <b-button
          size="sm"
          class="mr-2 float-right"
          variant="secondary"
          @click="groupDetails(data.item)"
        >
          {{ $t("page.groups.manage") }}
        </b-button>
      </template>
    </b-table>
  </div>
</template>

<script>
export default {
  props: {
    groups: {
      type: Array,
      default: () => []
    },
    fields: {
      type: Array,
      default: () => []
    },
    sortBy: {
      type: String,
      default: ""
    },
    sortDesc: {
      type: Boolean,
      default: false
    },
    retrieveDataCallback: {
      type: Function,
      default: () => {}
    }
  },
  data() {
    return {
      preview: false,
      currentCommunication: {},
      statusVariant: { active: "green", inactive: "default-red" },
      comPersmissionVariant: { true: "green", false: "default-red" }
    };
  },
  computed: {
    _sortBy: {
      get() {
        return this.sortBy;
      },
      set(value) {
        this.$emit("update:sortBy", value);
      }
    },
    _sortDesc: {
      get() {
        return this.sortDesc;
      },
      set(value) {
        this.$emit("update:sortDesc", value);
      }
    },
    sortIcon() {
      return this._sortDesc
        ? "M8 4a.5.5 0 0 1 .5.5v5.793l2.146-2.147a.5.5 0 0 1 .708.708l-3 3a.5.5 0 0 1-.708 0l-3-3a.5.5 0 1 1 .708-.708L7.5 10.293V4.5A.5.5 0 0 1 8 4z"
        : "M8 12a.5.5 0 0 0 .5-.5V5.707l2.146 2.147a.5.5 0 0 0 .708-.708l-3-3a.5.5 0 0 0-.708 0l-3 3a.5.5 0 1 0 .708.708L7.5 5.707V11.5a.5.5 0 0 0 .5.5z";
    }
  },
  methods: {
    setSort(newSortBy) {
      if (this._sortBy !== newSortBy) {
        this._sortBy = newSortBy;
        this._sortDesc = false;
      } else {
        this._sortDesc = !this._sortDesc;
      }
    },
    groupDetails(item) {
      this.$router.push({
        name: "GroupManagement",
        params: {
          groupId: item._id
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.sort-icon {
  width: 20px;
}
.body-container {
  /deep/ p {
    margin: 0;
  }
}
.status-container {
  margin-top: 0.3em;
  color: var(--red);
  border: 1px solid var(--red);
  text-align: center;
  border-radius: 5px;
  font-size: 0.9em;
}
.read {
  color: var(--green);
  border: 1px solid var(--green);
}
.pending {
  color: var(--orange);
  border: 1px solid var(--orange);
}
</style>
